<mg-report-table
  matSort
  [dataSourceService]="ds"
  (matSortChange)="ds.sort($event)">
  <mg-history-column [datasource]="ds"></mg-history-column>
  <mg-summary-column [datasource]="ds"></mg-summary-column>
</mg-report-table>
